 var addtocart_selector = '';
 var variant_dropdown_selector = '';
 var qty_selector ='ProductSelect-product-template';
 var enable_pvt_app ='yes';
 var show_floating_cart = 'no';
 var show_tbl_after_customer_logged_in = 'no';
 var redirect_cart_page = 'yes';
 var hide_price = 'no';
 var hide_price_text = 'Call for price'; 
 var hide_add_to_cart_btn = 'yes';
 var hide_variant_dropdowns = 'yes';
 var hide_qty_box = 'yes';
 var show_out_of_stock = 'yes';
 var currency_code_included = 'no';
 var default_qty_val = '0';
 var single_atc_status = 'NO';
 var variant_img_size = 'small';
 var enable_filter = 'no';